import {gql} from "@apollo/client";

export const GENERATE_PARCEL_DOWNLOAD_REPORT = gql`
    mutation GenerateParcelDownloadReport($filters: OrderFiltersTypeInput, $timezone: String, $warehouseId: Long!) {
        generateParcelDownloadReportForPickup(filters: $filters, timezone: $timezone, warehouseId: $warehouseId)
    }
`;

export interface GenerateParcelDownloadReportResponse {
    generateParcelDownloadReportForPickup: string;
}

export interface GenerateParcelDownloadReportVariables {
    filters?: any;
    timezone?: string;
    warehouseId: string | number;
}